import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from '@environments/environment';

declare const grecaptcha: any;

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule,
    MatFormFieldModule, MatInputModule, MatSelectModule,
    MatButtonModule, MatIconModule, MatProgressSpinnerModule,
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent implements OnInit {
  form: FormGroup;
  submitting = false;
  submitted = false;
  error = '';

  subjects = [
    { value: 'GENERAL_INQUIRY', label: 'General Inquiry' },
    { value: 'BUG_REPORT', label: 'Bug Report' },
    { value: 'PARTNERSHIP', label: 'Partnership / Business' },
    { value: 'FEATURE_REQUEST', label: 'Feature Request' },
  ];

  private captchaSiteKey = environment.recaptcha.siteKey;

  constructor(private fb: FormBuilder, private http: HttpClient) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(255)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(255)]],
      phone: ['', [Validators.maxLength(50)]],
      company: ['', [Validators.maxLength(255)]],
      subject: ['', [Validators.required]],
      message: ['', [Validators.required, Validators.maxLength(500)]],
    });
  }

  ngOnInit(): void {
    if (!(window as any).grecaptcha) {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?render=' + this.captchaSiteKey;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }

  get messageLength(): number {
    return this.form.get('message')?.value?.length || 0;
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitting = true;
    this.error = '';

    grecaptcha.ready(() => {
      grecaptcha.execute(this.captchaSiteKey, { action: 'contact' }).then((token: string) => {
        this.http.post(`${environment.api.feedback}/contact`, {
          ...this.form.value,
          recaptchaToken: token,
        }).subscribe({
          next: () => {
            this.submitted = true;
            this.submitting = false;
          },
          error: () => {
            this.error = 'Something went wrong. Please try again or email us at contact@gitcharger.com.';
            this.submitting = false;
          },
        });
      });
    });
  }

  resetForm(): void {
    this.form.reset();
    this.submitted = false;
    this.error = '';
  }
}
